// Shared metadata & helpers used by FranchisePage sub-components and elsewhere.
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const PRODUCTS_META = {
  'e-personalidade': { name: 'E-Personalidade', icon: 'solar:user-circle-linear' },
  'e-processual': { name: 'E-Processual', icon: 'solar:graph-up-linear' },
  'e-corpo': { name: 'E-Corpo', icon: 'solar:dumbbell-large-linear' },
  'e-vendas': { name: 'E-Vendas', icon: 'solar:cart-large-2-linear' },
  'e-got': { name: 'E-GOT', icon: 'solar:crown-line-linear' },
};

export const formatDateRange = (start, end) => {
  if (!start) return '';
  const a = parseISO(start);
  if (!end) return format(a, 'dd MMM yyyy', { locale: ptBR });
  const b = parseISO(end);
  const sameMonth = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  if (sameMonth) {
    return `${a.getDate()} a ${b.getDate()} ${format(a, 'MMM yyyy', { locale: ptBR })}`;
  }
  return `${format(a, 'dd MMM', { locale: ptBR })} a ${format(b, 'dd MMM yyyy', { locale: ptBR })}`;
};

// Return a wa.me link for the given franchise, or `fallback` if the
// franchise has no WhatsApp/phone. Callers pass the global CTA link
// (from useGlobalWaLink()) so admins can change it via /admin/system.
export const franchiseWhatsApp = (franchise, fallback = '#') => {
  if (!franchise) return fallback;
  const raw = (franchise.whatsapp || franchise.phone || '').replace(/\D/g, '');
  if (!raw) return fallback;
  return `https://wa.me/${raw.length <= 11 ? '55' + raw : raw}`;
};
